<template>
  <div>
    <div>
      <top-menu 
        :backVisible="true"
        :homeVisible="true"
        :aboutVisible="false"
      >
      </top-menu>
    </div>
    <div>
      <v-container fluid class="ma-0 pa-0 mt-6">
        <v-row dense>
          <v-col class="pa-0 ma-0">
            <div class="text-center"><label class="font-weight-black blue--text text--darken-4 title">Search Specialty Track OJTs</label></div>
          </v-col>
        </v-row>
        <v-row class="justify-center" no-gutters>
          <v-col class="text-center">
            <br />
            <br />
            <v-btn color="blue darken-4" dark width="175" to="/spectracks/bytrack">By Track</v-btn>
            <br />
            <br />
            <v-btn color="blue darken-4" dark width="175" to="/spectracks/byunit">By Unit</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <!-- Begin - Loading Data Modal -->
    <v-dialog
      v-model="isLoading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Loading Data...
          <v-progress-linear
            indeterminate
            rounded
            color="white"
            class="mb-0"
            height="20px"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End - Loading Data Modal -->

  </div>    
</template>

<script>
export default {
  name: 'SpecialtyTracks',
  components: {
  },
  data() {
    return {
      isLoading: false,
    }
  },
  mounted() {
    this.setBackButtonVisibility(true);
    this.setHomeButtonVisibility(true);
  },
  methods: {
  }
}
</script>